import React from "react";
import { letterGenderPhrases, parseLetterGender } from "./letterGenderUtils";
import sign from "./sign.png";
type ExperienceLetterProps = {
  date?: string;
  refNo?: string;
  candidateName?: string;
  candidateId?: string;
  designation?: string;
  fromDate?: string;
  toDate?: string;
  /** From onboarding (e.g. `Male` / `Female`); drives pronouns in body text. */
  gender?: string | null;
};

const Expe: React.FC<ExperienceLetterProps> = ({
  date = "14/08/2025",
  refNo = "Vic/25/Aug/14",
  candidateName = "Sinjini Saha",
  candidateId = "Vic/25/May/08",
  designation = "HR Recruiter Intern",
  fromDate = "DD/MM/YYYY",
  toDate = "DD/MM/YYYY",
  gender = null,
}) => {
  const { possessiveLower, objectLower, subjectLower } = letterGenderPhrases(
    parseLetterGender(gender)
  );

  return (
    <div
      className="w-[794px] h-[1123px] overflow-hidden bg-white text-black shadow-sm p-8"
      style={{ boxSizing: "border-box", fontFamily: '"Times New Roman", serif' }}
    >

      <div
        className="w-full h-full flex flex-col"
        style={{ boxSizing: "border-box" }}
      >
        <div className="flex items-start justify-between border-b border-gray-300 pb-2 align-center">
          <div className="pt-0 self-start">
            <img
              src="/assets/images/earlyjobsCropped.png"
              alt="EarlyJobs"
              className="h-20 w-auto object-contain"
            />
          </div>
          <div className="max-w-[60%] text-left">
            <p className="text-xl font-bold text-[#1e355f]">Victa EarlyJobs Technologies Pvt. Ltd.</p>
            <p className="mt-1 text-sm text-gray-800 leading-snug">
              No. 53, HustleHub, 5th Cross Rd, Near Sony World Signal,<br /> Koramangala, Bengaluru, Karnataka 560034
            </p>
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between text-base">
          <p>Dated: {date}</p>
          <p>Ref: - {refNo}</p>
        </div>

        <div className="flex-1 flex flex-col w-[95%] m-auto">
          <div className="text-center mt-[20px]">
            <p className="text-2xl font-bold underline">To Whom It May Concern</p>
          </div>

          <div className="mt-6 space-y-5 text-[16px] leading-relaxed">
            <p>
              This is to certify that <b>{candidateName}</b> was associated with <b>EarlyJobs.ai</b> under
              <b>Victa EarlyJobs Technologies Private Limited</b> from <b>{fromDate}</b> to <b>{toDate}</b>.
            </p>

            <p>
              During this period, {subjectLower} held the role of <b>{designation}</b> and was involved in
              responsibilities including, but not limited to:
            </p>
            <p>
              During {possessiveLower} association with the organization, <b>{candidateName}</b>:
            </p>
            <ul className="ml-4 space-y-1">
              <li className="flex items-start gap-2">
                <span className="mt-[2px] text-base leading-none">•</span>
                <span>Contributed to assigned responsibilities with professionalism and accountability</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-[2px] text-base leading-none">•</span>
                <span>Supported team objectives and organizational goals through effective execution</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-[2px] text-base leading-none">•</span>
                <span>Demonstrated adaptability, collaboration, and a positive work ethic</span>
              </li>
            </ul>

            <p>
              Throughout <b>{possessiveLower}</b> tenure, <b>{candidateName}</b> demonstrated a high level of professionalism,
              ownership, and commitment. <b>{subjectLower}</b> consistently displayed strong problem-solving abilities,
              adaptability in a fast-paced environment, and a collaborative approach while working with cross-functional
              teams.
            </p>

            <p className="pb-0">
              <b>{candidateName}</b> maintained good conduct during the association and complied with all organizational policies
              and ethical standards. We found <b>{objectLower}</b> to be dependable and capable, and <b>{subjectLower}</b> made
              meaningful contributions to the organization during {possessiveLower} engagement.<br />

              We wish <b>{candidateName}</b> every success in <b>{possessiveLower}</b> future professional and personal endeavors.
            </p>

            <div className="block w-full h-[10px] ">

            </div>
            <div className="mt-auto  flex justify-end">
              <div className="flex flex-col items-end justify-end">
                <p>With Best Wishes, </p>
                <p>For Victa EarlyJobs Technologies Pvt. Ltd</p>
                <img src={sign} alt="sign" className="mt-1 w-[40%] h-30" />
                <p>Authorized Signatory</p>
                <p>Bangalore</p>
              </div>


            </div>
          </div>


        </div>

        <div className="mt-4 border-t border-dashed border-gray-300 pt-3 text-sm">
          <div className="flex items-center justify-between">
            <p>www.earlyjobs.in</p>
            <p>hr@earlyjobs.in</p>
            <p>+91 821 7527926</p>
          </div>
          <p className="mt-1 text-center text-[#ea694e]">Hire your ideal team.10X Quicker.</p>
        </div>
      </div>
    </div>
  );
};

export default Expe;
